import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import Wrapper from '../Wrapper';

dayjs.extend(LocalizedFormat);

const DateTime = ({ format, customFormat, modifier, prefix, suffix }) => {
  const dateFormat = customFormat || format;

  if (!dateFormat) return null;

  const formattedDate = dayjs().format(dateFormat);

  return (
    <Wrapper className="date" modifiers={modifier}>
      {prefix} {formattedDate} {suffix}
    </Wrapper>
  );
};

DateTime.propTypes = {
  format: PropTypes.string.isRequired,
  customFormat: PropTypes.string,
  modifier: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string
};

DateTime.defaultProps = {
  customFormat: '',
  modifier: null,
  prefix: '',
  suffix: ''
};

export default DateTime;
